<div class="section" [style.width.px]="width">
  <div #categoryHeader class="category-container sticky-header"
       [style.height.px]="headerHeight">
    <div class="row-container flex-end">
      <a class="fb center-container" target="_blank" [href]="fbLink">
        <app-image-loading src="assets/icon_fb.svg" alt="fb"
                           [clickable]="true"
                           [middle]="true"
                           [targetWidth]="9"
                           [targetHeight]="19"/>
      </a>
      <a class="ig center-container" target="_blank" [href]="igLink">
        <app-image-loading src="assets/icon_ig.svg" alt="ig"
                           [clickable]="true"
                           [middle]="true"
                           [targetWidth]="20"
                           [targetHeight]="20"/>
      </a>
      <a class="line center-container" target="_blank" [href]="lineLink">
        <app-image-loading src="assets/icon_line.svg" alt="line"
                           [clickable]="true"
                           [middle]="true"
                           [targetWidth]="20"
                           [targetHeight]="20"/>
      </a>
    </div>
    <div class="nav flex full-width relative">
      <button class="margin-left" appFocusRemove (click)="goHome()">
        <app-image-loading class="logo" src="assets/lativ_logo.svg" alt="lativ"
                           [clickable]="true"
                           [targetWidth]="80"
                           [targetHeight]="31"/>
      </button>
      @if (showSnow()) {
        <button class="absolute-logo" appFocusRemove (click)="goHome()">
          <app-image-loading class="logo" src="assets/xmas_logo.gif" alt="lativ"
                             [clickable]="true"
                             [targetWidth]="135"
                             [targetHeight]="85"/>
        </button>
      }
      <div class="row-container space-between menu-margin full-width">
        <div class="menu-container row-container">
          <div class="row-container"
               *ngFor="let big of viewModel.apiResult().bigCategories; trackBy: trackByFn">
            <a class="menu-item center-container relative"
               [class.selected]="viewModel.currentBigId() === big.nameEn"
               [routerLink]="big.nameEn | miniHomeLink"
               (click)="onChangeCategory(big.nameEn, $event)">
              {{big.nameEn}}
              @if (showSnow()) {
                @switch (big.nameEn) {
                  @case ("WOMEN") {
                    <app-image-loading src="assets/xmas_women.svg" alt="lativ"
                                       [clickable]="true"
                                       [targetWidth]="22"
                                       [targetHeight]="22"/>
                  }
                  @case ("MEN") {
                    <app-image-loading src="assets/xmas_men.svg" alt="lativ"
                                       [clickable]="true"
                                       [targetWidth]="22"
                                       [targetHeight]="22"/>
                  }
                  @case ("KIDS") {
                    <app-image-loading src="assets/xmas_kid.svg" alt="lativ"
                                       [clickable]="true"
                                       [targetWidth]="22"
                                       [targetHeight]="22"/>
                  }
                  @case ("BABY") {
                    <app-image-loading src="assets/xmas_baby.svg" alt="lativ"
                                       [clickable]="true"
                                       [targetWidth]="22"
                                       [targetHeight]="22"/>
                  }
                  @case ("SPORTS") {
                    <app-image-loading src="assets/xmas_sport.svg" alt="lativ"
                                       [clickable]="true"
                                       [targetWidth]="22"
                                       [targetHeight]="22"/>
                  }
                }
              }
            </a>
            <div class="menu-divider"></div>
          </div>
          <a class="menu-item relative" *ngIf="viewModel.apiResult().bigCategories.length"
             [class.selected]="viewModel.styleSelected()"
             [routerLink]="outfitLink"
             (click)="goStyle($event)">
            <span i18n>STYLE</span>
          </a>
        </div>
        <div class="row-container">
          <app-search-menu class="search-margin-right"/>
          <app-menu-cart class="margin-right relative"/>
          <div class="menu-container user-btn-width row-container">
            @if (viewModel.apiResult().bigCategories.length) {
              <ng-container *appSsrExclude>
                @if (!authService.isLogin()) {
                  <button class="user-btn user-btn-width" appFocusRemove (click)="login()">
                    <div class="center-container space-between">
                      <app-image-loading src="assets/icon_login_a.svg" alt="登入/註冊" i18n-alt
                                         [clickable]="true"
                                         [targetWidth]="22"
                                         [targetHeight]="22"/>
                      <span i18n>登入/註冊</span>
                    </div>
                  </button>
                } @else {
                  <button class="user-btn user-btn-width space-between center-container" appFocusRemove
                          [matMenuTriggerFor]="userMenu"
                          [matMenuTriggerRestoreFocus]="false">
                    <app-image-loading src="assets/icon_login_b.svg" alt="會員中心" i18n-alt
                                       [clickable]="true"
                                       [targetWidth]="22"
                                       [targetHeight]="22"/>
                    <span class="selected" i18n>會員中心</span>
                  </button>
                  <mat-menu class="user-menu-panel" #userMenu yPosition="below" overlapTrigger="false">
                    <div class="column-container user-menu">
                      <button appFocusRemove i18n (click)="toPath(paths.NOTIFICATION)">消息中心</button>
                      <button appFocusRemove i18n (click)="toPath(paths.FAVORITE)">收藏/貨到通知</button>
                      <button appFocusRemove i18n (click)="toPath(paths.ORDERS)">我的訂單</button>
                      <button appFocusRemove i18n (click)="toPath(paths.REFUND_ACCOUNT)">退款帳戶</button>
                      <button appFocusRemove i18n (click)="toPath(paths.PROFILE)">個人資訊</button>
                      <button appFocusRemove i18n (click)="logout()">會員登出</button>
                    </div>
                  </mat-menu>
                }
              </ng-container>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
  @if (viewModel.currentCategory()) {
    <div class="flex">
      @if (showCategory) {
        <div class="sidenav">
          <a class="medium-text row-container hover-underline" appFocusRemove i18n
             [routerLink]="viewModel.currentCategory().nameEn | miniHomeLink"
             (click)="onChangeCategory(viewModel.currentCategory().nameEn, $event)">
            <span>{{viewModel.bigCategoryName()}}新品 ＆ 熱銷</span>
          </a>
          <div class="category-items section-margin">
            @for (event of viewModel.events(); track event.id) {
              <a class="event-text small-text"
                 [routerLink]="event.id | eventLink: viewModel.currentBigId()"
                 (click)="openSalesEvent(event, $event)">
                {{event.title}}．{{event.subTitle}}
              </a>
            }
          </div>
          <div class="divider section-margin"></div>
          @for (medium of viewModel.currentCategory().mediumCategories; track medium.nameEn) {
            @if (medium.smallCategories; as items) {
              @if (items.length) {
                <div class="medium-text section-margin">{{medium.name}}</div>
                <div class="category-items small-margin">
                  @for (small of items; track small.nameEn) {
                    <a class="small-text hover-underline"
                       [routerLink]="viewModel.currentBigId() | categoryLink: medium.nameEn: small.nameEn"
                       [class.selected]="medium.nameEn === viewModel.currentMediumId() && small.nameEn === viewModel.currentSmallId()"
                       (click)="onSmallChange(medium.nameEn, small.nameEn, $event)">
                      {{small.name}}
                    </a>
                  }
                </div>
              }
            }
          }
        </div>
      }
      @if (template) {
        <ng-container [ngTemplateOutlet]="template"/>
        @if (!hiddenTop && viewModel.canScroll()) {
          <button class="floating" appFocusRemove
                  [style.transform]="floatingMargin"
                  (click)="scrollToTop()">
            <app-image-loading i18n-alt alt="TOP" src="assets/icon_top_text.svg"
                               [targetWidth]="50"
                               [targetHeight]="50"
                               [clickable]="true"/>
          </button>
        }
      }
    </div>
  }
  @if (showBottomBar) {
    <app-bottom-info-bar/>
  }
</div>

<!--Desktop 大部分頁面都有使用 app-marketing-category, 而線上客服也需要如此, 所以延遲載入 app-customer-service 放在這裡-->
@defer (when csDeferService.loadCs() && authService.isLogin()) {
  <div class="cs-btn">
    <app-customer-service/>
  </div>
}
